export default "__VITE_ASSET__e96a667e__"